var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"nice-block",style:(_vm.niceBlockStyles)},[(_vm.$slots.detail && !_vm.hideDetail)?_c('div',{staticClass:"detail-wrap",style:(_vm.niceDetailStyles)},[_vm._t("detail")],2):_vm._e(),_c('div',{staticClass:"main-wrap",style:(_vm.niceMainStyles)},[_vm._t("main")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }